import { APP_PERMISSIONS } from '@exam-center/permission';
import { Button, type ButtonProps } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { WithPermission } from '@shared/permissions';

import { BlockedRecordRevocationFormModal } from '../blocked-record-revocation-form-modal';

type BlockedRecordRevocationButtonProps = Pick<ButtonProps, 'disabled'> & {
  onCompleted: () => void;
};

export default function BlockedRecordRevocationButton(
  props: Readonly<BlockedRecordRevocationButtonProps>,
) {
  const { disabled: isDisabled, onCompleted } = props;
  const [isRevocationModalOpen, { open: openRevocationModal, close: closeRevocationModal }] =
    useDisclosure(false);

  const handleCompleted = () => {
    onCompleted();
    closeRevocationModal();
  };

  return (
    <WithPermission
      requiredPermission={APP_PERMISSIONS.ADMIN_BLOCKLIST_MANAGEMENT.BLOCKED_USER.UPDATE}
    >
      <Button size='large' color='error' disabled={isDisabled} onClick={openRevocationModal}>
        เพิ่มเป็นผู้ทุจริต
      </Button>
      <BlockedRecordRevocationFormModal
        open={isRevocationModalOpen}
        onCompleted={handleCompleted}
        onClose={closeRevocationModal}
      />
    </WithPermission>
  );
}
